/******************************************************************************
 *
 * Copyright (c) 2019-2020 ServiceActivator Inc. All Rights Reserved.
 * 
 * Unauthorized copying of the code in this file, completely or partially, 
 * via any medium is strictly prohibited.
 *
 * Proprietary and Confidential.
 * 
 * Written by 'Vishal Goel’ <vishal@wakencode.com>, February 2020
 *
 *****************************************************************************/

import React from "react";
import Toast from "./Toast/Toast";
import { Authenticator } from 'aws-amplify-react';
import { Route, Switch, withRouter, Redirect } from "react-router-dom";
import Tracker from "../src/Tracker/container/MapContainer/MapContainer";
import Geofence from "../src/Geofence/container/GeoWrapper";
import Loading from "../src/Loading/Loading";


const App = props => {
  return (
    <Authenticator hideDefault={true} >
      <Switch>
        <Route path="/loading" component={Loading} />
        <Route path="/live" component={Tracker} />
        <Route path="/geofence" component={Geofence} />
        <Redirect to="/loading" />
      </Switch>
      <Toast />
    </Authenticator>
  );
};

export default withRouter(App);
